import { useRoutes } from 'react-router-dom';

import { useAuth } from '@/lib/auth';
import { privateRoutes } from '@/routes/private';
import { privateRoutesNotLogged } from '@/routes/privateNotLogged';
import { publicRoutes } from '@/routes/public';

export const AppRoutes = () => {
  const { isLogged } = useAuth();
  const routes = isLogged() ? privateRoutes : privateRoutesNotLogged;
  const element = useRoutes([...routes, ...publicRoutes]);

  return <>{element}</>;
};
